import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { ConfigService } from '../@vex/services/config.service';
import { Settings } from 'luxon';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { NavigationService } from '../@vex/services/navigation.service';
import icLayers from '@iconify/icons-ic/twotone-layers';
import icAssigment from '@iconify/icons-ic/twotone-assignment';
import icContactSupport from '@iconify/icons-ic/twotone-contact-support';
import icDateRange from '@iconify/icons-ic/twotone-date-range';
import icChat from '@iconify/icons-ic/twotone-chat';
import icPerson from '@iconify/icons-ic/person';
import icGroup from '@iconify/icons-ic/group'
import icContacts from '@iconify/icons-ic/twotone-contacts';
import icAssessment from '@iconify/icons-ic/twotone-assessment';
import icLock from '@iconify/icons-ic/twotone-lock';
import icWatchLater from '@iconify/icons-ic/twotone-watch-later';
import icError from '@iconify/icons-ic/twotone-error';
import icAttachMoney from '@iconify/icons-ic/twotone-attach-money';
import icPersonOutline from '@iconify/icons-ic/twotone-person-outline';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icHelp from '@iconify/icons-ic/twotone-help';
import icBook from '@iconify/icons-ic/twotone-book';
import icBubbleChart from '@iconify/icons-ic/twotone-bubble-chart';
import icFormatColorText from '@iconify/icons-ic/twotone-format-color-text';
import icStar from '@iconify/icons-ic/twotone-star';
import icViewCompact from '@iconify/icons-ic/twotone-view-compact';
import icPictureInPicture from '@iconify/icons-ic/twotone-picture-in-picture';
import icSettings from '@iconify/icons-ic/twotone-settings';
import { LayoutService } from '../@vex/services/layout.service';
import icUpdate from '@iconify/icons-ic/twotone-update';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { SplashScreenService } from '../@vex/services/splash-screen.service';
import { Style, StyleService } from '../@vex/services/style.service';
import icChromeReaderMode from '@iconify/icons-ic/twotone-chrome-reader-mode';
import { ConfigName } from '../@vex/interfaces/config-name.model';
import icMail from '@iconify/icons-ic/twotone-mail';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Frotas - OSS RDO';

  constructor(private configService: ConfigService,
              private styleService: StyleService,
              private renderer: Renderer2,
              private platform: Platform,
              @Inject(DOCUMENT) private document: Document,
              @Inject(LOCALE_ID) private localeId: string,
              private layoutService: LayoutService,
              private route: ActivatedRoute,
              private router: Router,
              private navigationService: NavigationService,
              private splashScreenService: SplashScreenService) {
    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    /**
     * Customize the template to your needs with the ConfigService
     * Example:
     *  this.configService.updateConfig({
     *    sidenav: {
     *      title: 'Custom App',
     *      imageUrl: '//placehold.it/100x100',
     *      showCollapsePin: false
     *    },
     *    footer: {
     *      visible: false
     *    }
     *  });
     */

    /**
     * Config Related Subscriptions
     * You can remove this if you don't need the functionality of being able to enable specific configs with queryParams
     * Example: example.com/?layout=apollo&style=default
     */
    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('rtl')),
      map(queryParamMap => coerceBooleanProperty(queryParamMap.get('rtl'))),
    ).subscribe(isRtl => {
      this.configService.updateConfig({
        rtl: isRtl
      });
    });

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('layout'))
    ).subscribe(queryParamMap => this.configService.setConfig(queryParamMap.get('layout') as ConfigName));

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('style'))
    ).subscribe(queryParamMap => this.styleService.setStyle(queryParamMap.get('style') as Style));



    this.navigationService.items = [
      {
        type: 'subheading',
        label: 'Frotas',
        permission: 'Header.Menu.Frotas.Assets',
        children: [
          {
            type: 'link',
            label: 'Frotas - Mapa',
            icon: icAssigment,
            route: '/maps',
            permission: 'Header.Menu.Frotas.Assets'
          },  
          {
            type: 'link',
            label: 'Consumo CO2',
            icon: icAssigment,
            route: '/consumo/consumo',
            permission: 'Header.Menu.Frotas.ConsumoCO2'
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Ordens Serviços',
        permission: 'Header.Menu.OrdensServico',
        children: [
          {
            type: 'link',
            label: 'Execução de Processos',
            icon: icAssigment,
            route: '/process/execute',
            permission: 'Header.Menu.OrdensServico.ExecucaoProcessos',
          },
          {
            type: 'link',
            label: 'Consultar Processos',
            icon: icAssigment,
            route: '/process/consult',
            permission: 'Header.Menu.OrdensServico.ConsultarProcessos'
          },
          {
            type: 'link',
            label: 'Requisição de Processos',
            icon: icAssigment,
            route: '/',
            permission: 'Header.Menu.OrdensServico.RequisicaoProcessos'
          },
        ]
      },
      /*
      {
        type: 'subheading',
        label: 'Serviços Manutenção',
        permission: 'Header.Menu.OrdensServicoManutencao',
        children: [
          {
            type: 'link',
            label: 'Execução de Processos',
            icon: icAssigment,
            route: '/processOSM/execute',
            permission: 'Header.Menu.OrdensServicoManutencao.ExecucaoProcessos',
          },
          {
            type: 'link',
            label: 'Consultar Processos',
            icon: icAssigment,
            route: '/processOSM/consult',
            permission: 'Header.Menu.OrdensServicoManutencao.ConsultarProcessos'
          },
        ]
      },
      */
      {
        type: 'subheading',
        label: 'Cadastros & Consultas',
        permission: 'Header.Menu.CadastrosConsultas',
        children: [          
          {
            type: 'link',
            label: 'Frotas - Lista',
            icon: icAssigment,
            route: '/asset',
            permission: 'Header.Menu.CadastrosConsultas.Assets'
          },              
          {
            type: 'link',
            label: 'Operators',
            icon: icAssigment,
            route: '/operator-control/operator',
            permission: 'Header.Menu.CadastrosConsultas.Operators',
          }
        ]
      },
      {
        type: 'subheading',
        label: 'Parâmetros',
        permission: 'Header.Menu.Parametros',
        children: [
          {
            type: 'dropdown',
            label: 'Parâmetros Corporativos',
            icon: icBook,
            permission: 'Header.Menu.Parametros.ParametrosCorporativos',
            children: [
              {
                type: 'link',
                label: 'Segmento',
                route: '/business-line',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.BusinessLine',
                routerLinkActiveOptions: { exact: true }
              },
              {
                type: 'link',
                label: 'Divisão',
                route: '/division',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Division',
                routerLinkActiveOptions: { exact: true }
              },              
              {
                type: 'link',
                label: 'Localização',
                icon: icAssigment,
                route: '/warehouse',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Warehouse',
              },
              {
                type: 'link',
                label: 'Geolocalização',
                icon: icAssigment,
                route: '/geolocation',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Geolocation',
              },
              {
                type: 'link',
                label: 'Treinamento',
                icon: icAssigment,
                route: '/training',
                permission: 'Header.Menu.Parametros.ParametrosCorporativos.Training',
              }
            ]
          },
          {
            type: 'dropdown',
            label: 'Parâmetros Equipamentos',
            permission: 'Header.Menu.Parametros.ParametrosEquipamentos',
            icon: icBook,
            children: [
              {
                type: 'link',
                label: 'Tipos de Frotas',
                route: '/asset-type',
                routerLinkActiveOptions: { exact: true },
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.AssetType',
              },
              {
                type: 'link',
                label: 'Dispositivos',
                icon: icAssigment,
                route: '/device',
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.Devices',
              },
              {
                type: 'link',
                label: 'Manutenções',
                icon: icAssigment,
                route: '/maintenance',
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.Maintenances',
              },
              {
                type: 'link',
                label: 'Câmeras',
                icon: icAssigment,
                route: '/cameras/cameras-parameters',
                permission: 'Header.Menu.Parametros.ParametrosEquipamentos.Devices',
              },

            ]
          }
        ]
      },
      {
        type: 'subheading',
        label: 'Administração',
        permission: 'Header.Menu.Administracao',
        children: [
          {
            type: 'link',
            label: 'Usuários',
            icon: icPerson,
            route: '/user',
            permission: 'Header.Menu.Administracao.Usuarios',
          },
          {
            type: 'link',
            label: 'Funções',
            icon: icGroup,
            route: '/role',
            permission: 'Header.Menu.Administracao.Funcoes',
          },
          {
            type: 'link',
            label: 'Novos Usuários',
            icon: icPerson,
            route: '/novos-usuarios',
            permission: 'Header.Menu.Administracao',
          },
        ]
      }
    ];
    const syncPlantonistaMenu = () => {
      const role = (localStorage.getItem('role') || '').trim().toLocaleLowerCase();
      const orders = this.navigationService.items.find(item =>
        item.type === 'subheading' && item.label === 'Ordens Serviços');
      if (orders && orders.type === 'subheading') {
        const allowedOperations = ['operação', 'administrador', 'supervisor', 'analista'].includes(role);
        const operationIndex = orders.children.findIndex(item =>
          item.type === 'link' && item.route === '/process/operations');
        orders.permission = allowedOperations ? undefined : 'Header.Menu.OrdensServico';
        if (allowedOperations && operationIndex < 0) {
          orders.children.push({ type: 'link', label: 'Operações', icon: icAssigment,
            route: '/process/operations' });
        } else if (!allowedOperations && operationIndex >= 0) {
          orders.children.splice(operationIndex, 1);
        }
      }
      // (AJUSTE NECESSÁRIO) A permissão do grupo varia; o rótulo permite sincronizar os itens de usuários após cada navegação.
      const administration = this.navigationService.items.find(item => item.type === 'subheading' && item.label === 'Administração');
      if (!administration || administration.type !== 'subheading') { return; }
      const index = administration.children.findIndex(item => item.type === 'link' && item.route === '/plantonista');
      const allowed = role === 'analista' || role === 'supervisor' || role === 'administrador';
      const usersAllowed = role.split(',').some(value => ['analista', 'supervisor', 'administrador'].includes(value.trim()));
      administration.permission = usersAllowed ? undefined : 'Header.Menu.Administracao';
      for (const item of administration.children) {
        if (item.type === 'link' && item.route === '/user') {
          item.permission = usersAllowed ? undefined : 'Header.Menu.Administracao.Usuarios';
        }
        if (item.type === 'link' && item.route === '/novos-usuarios') {
          item.permission = usersAllowed ? undefined : 'Header.Menu.Administracao';
        }
      }
      if (allowed && index < 0) {
        administration.children.push({ type: 'link', label: 'Plantonista', icon: icPerson,
          route: '/plantonista' });
      } else if (!allowed && index >= 0) {
        administration.children.splice(index, 1);
      }
    };
    syncPlantonistaMenu();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(syncPlantonistaMenu);
  }
}
